import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "ScreenReaderAnnouncer__StyledDiv",
  componentId: "sc-1iyv7va-0"
})(["{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0;}"]);
export function ScreenReaderAnnouncer({
  announcedText,
  use = 'polite'
}) {
  return /*#__PURE__*/_jsx(StyledDiv, {
    "aria-live": use,
    "aria-atomic": "true",
    children: announcedText
  });
}